import { Hospital, useSearchHospital } from 'all-in-one-shared-api';
import { Key, SWRConfiguration } from 'swr';
import { useMemo } from 'react';

interface HospitalSearchResponse {
  results: Hospital[] | undefined;
  totalCount: number;
}

type SearchHospitalWithPageRes = {
  shouldFetch: (b: boolean) => void;
  data: HospitalSearchResponse;
  mutate: () => void;
};

type SearchHospitalWithPageProps = {
  key: Key;
  accessToken: string;
  latitude?: number;
  longitude?: number;
  radius?: number;
  searchQuery?: string;
  area?: string;
  districts?: string[];
  pageIndex?: number;
  pageSize?: number;
  config?: SWRConfiguration;
};

export function useSearchHospitalWithPage({
  key,
  accessToken,
  latitude,
  longitude,
  radius,
  searchQuery,
  area,
  districts,
  pageIndex = 0,
  pageSize = 100,
  config,
}: SearchHospitalWithPageProps): SearchHospitalWithPageRes {
  const {
    data: apiData,
    shouldFetch,
    mutate,
  } = useSearchHospital(key, accessToken, latitude, longitude, radius, searchQuery, area, districts, config);
  const indexStart = (pageIndex - 1) * pageSize;
  const indexEnd = indexStart + pageSize;

  return useMemo(() => {
    return {
      shouldFetch,
      mutate,
      data: { results: apiData?.slice(indexStart, indexEnd), totalCount: apiData?.length ?? 0 },
    };
  }, [mutate, apiData, indexStart, indexEnd, shouldFetch]);
}
